import React from 'react';
import { Text } from '@perch-labs/shrike';
import { useMount, useUnmount } from 'react-use';
import { hideHelpWidget, showHelpWidget } from 'utils/help-widget';
import { copyFor } from 'config';
import { Modal } from 'components/modals/modal';

const getCopy = copyFor('settings.moving.movingExplained');

interface Props {
  onClose: () => void;
}

export const MovingExplainedModal = ({ onClose }: Props) => {
  const subHeaders = getCopy('subHeaders');
  const paragraphs = getCopy('paragraphs');

  useMount(() => {
    hideHelpWidget();
  });

  useUnmount(() => {
    showHelpWidget();
  });

  return (
    <Modal onClose={onClose}>
      <Text textStyle="heading800" tag="h1">
        {getCopy('title')}
      </Text>
      <Text margin={{ top: '16px' }}>{getCopy('firstParagraph')}</Text>
      {subHeaders.map((subHeader, index) => (
        <div key={subHeader[index]}>
          <Text
            textStyle="heading700"
            tag="h2"
            margin={{ bottom: '16px', top: '40px' }}
          >
            {subHeaders[index]}
          </Text>
          <Text>{paragraphs[index]}</Text>
        </div>
      ))}
    </Modal>
  );
};
